import React, { FC } from 'react';

import { useLang } from 'hooks';
import { DashboardLayout } from 'layouts';
import { Grid } from 'components/ui';
import { Profile } from 'types/models';

import Details from './Details';
import Language from './Language';
import PasswordChange from './PasswordChange';
import Verification from './Verification';

type ProfileViewProps = {
  profile: Profile;
};

const ProfileView: FC<ProfileViewProps> = ({ profile }) => {
  const lang = useLang();

  return (
    <DashboardLayout title={lang.get('profile.title')}>
      <Grid.Row>
        <Grid.Col md={12}>
          <Grid.Row>
            <Grid.Col>
              <Details profile={profile} />
            </Grid.Col>
            <Grid.Col>
              <Verification />
            </Grid.Col>
          </Grid.Row>
        </Grid.Col>
        <Grid.Col md={12}>
          <Grid.Row>
            <Grid.Col>
              <PasswordChange />
            </Grid.Col>
            <Grid.Col>
              <Language />
            </Grid.Col>
          </Grid.Row>
        </Grid.Col>
      </Grid.Row>
    </DashboardLayout>
  );
};

export default ProfileView;
